import { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { TYPE } from '@/theme/typography';
import CompensationPayrollTab from './CompensationPayrollTab';
import MyFinancesTab from './MyFinancesTab';
import PaymentDetailsPage from '@/pages/employee/PaymentDetailsPage';

interface PayFinancesTabProps {
  emp: any;
  currencyCode: string;
  initialSubTab?: number;
}

export default function PayFinancesTab({ emp, currencyCode, initialSubTab = 0 }: PayFinancesTabProps) {
  const [subTab, setSubTab] = useState(initialSubTab);

  return (
    <Box>
      <Tabs
        value={subTab}
        onChange={(_, v) => setSubTab(v)}
        sx={{
          mb: 2.5,
          minHeight: 36,
          '& .MuiTab-root': {
            textTransform: 'none', fontWeight: TYPE.semibold, fontSize: TYPE.sm,
            minHeight: 36, py: 0.5, px: 2, borderRadius: '8px', mr: 1,
          },
          '& .Mui-selected': { bgcolor: 'primary.main', color: 'white !important' },
          '& .MuiTabs-indicator': { display: 'none' },
        }}
      >
        <Tab label="Compensation & Payslips" />
        <Tab label="Loans & Savings" />
        <Tab label="Payment Details" />
      </Tabs>

      {subTab === 0 && emp && <CompensationPayrollTab emp={emp} currencyCode={currencyCode} />}
      {subTab === 1 && <MyFinancesTab />}
      {subTab === 2 && <PaymentDetailsPage />}
    </Box>
  );
}
